import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import './Oldredirect.css';
import axios from 'axios';


function Oldredirect() {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const getAuthToken = () => {
  // Replace this with your actual token retrieval method
  return localStorage.getItem('token');
};
 const handleFileUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // Validate file type
  const allowedTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                       'application/vnd.ms-excel', 'text/csv'];
  
  if (!allowedTypes.includes(file.type)) {
    setUploadStatus('Error: Please select a valid Excel file (.xlsx, .xls) or CSV file.');
    return;
  }

  setUploadedFile(file);
  setIsUploading(true);
  setUploadStatus('Processing file...');

  const reader = new FileReader();
  reader.onload = async (e) => {
    try {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      console.log('Processed data:', jsonData);
      
      // Get authentication token
      const token = getAuthToken();
      if (!token) {
        setUploadStatus('✗ Authentication required. Please log in first.');
        setIsUploading(false);
        return;
      }

      // Upload to API
      setUploadStatus('Uploading to server...');
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/bulkupload`, {
        data: jsonData,
        fileName: file.name
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        setUploadStatus(`✓ Successfully uploaded "${file.name}" with ${jsonData.length} rows. Server response: ${response.data.message || 'Upload completed'}`);
      }
      setIsUploading(false);
      
    } catch (error) {
      console.error('Upload error:', error);
      
      if (error.response) {
        // Server responded with error status
        const status = error.response.status;
        const message = error.response.data?.message || 'Server error';
        
        if (status === 401) {
          setUploadStatus('✗ Authentication failed. Please log in again.');
        } else if (status === 403) {
          setUploadStatus('✗ Access denied. You don\'t have permission to upload files.');
        } else {
          setUploadStatus(`✗ Upload failed: ${message}`);
        }
      } else if (error.request) {
        // Network error
        setUploadStatus('✗ Network error. Please check your connection and try again.');
      } else {
        // File processing error
        setUploadStatus('✗ Error processing file. Please check the file format and try again.');
      }
      
      setIsUploading(false);
    }
  };

  reader.onerror = () => {
    setUploadStatus('✗ Error reading file. Please try again.');
    setIsUploading(false);
  };

  reader.readAsBinaryString(file);
};

  const triggerFileUpload = () => {
    document.getElementById('fileInput').click();
  };

  const handleDownload = () => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = '/OldredirectXl.xlsx'; // Path to your Excel file in public folder
    link.download = 'Student_Data_Template.xlsx'; // Name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const clearUploadStatus = () => {
    setUploadStatus('');
    setUploadedFile(null);
    // Clear the file input
    document.getElementById('fileInput').value = '';
  };

  return (
    <div className="oldredirect-container">
      <div className="header-section">
        <h2 className="page-title">Student Data Management</h2>
        <p className="page-description">
          Upload student data from Excel files or download a formatted template with all required fields
        </p>
      </div>

      <div className="main-content">
        <div className="button-section">
          <div className="button-group">
            <button 
              className={`btn btn-upload ${isUploading ? 'loading' : ''}`}
              onClick={triggerFileUpload}
              disabled={isUploading}
            >
              <span className="btn-icon">📤</span>
              <span className="btn-text">
                <span className="btn-title">
                  {isUploading ? 'Processing...' : 'Upload Excel File'}
                </span>
                <span className="btn-subtitle">
                  {isUploading ? 'Please wait...' : 'Select .xlsx, .xls, or .csv file'}
                </span>
              </span>
            </button>

            <button 
              className="btn btn-download" 
              onClick={handleDownload}
            >
              <span className="btn-icon">📥</span>
              <span className="btn-text">
                <span className="btn-title">Download Template</span>
                <span className="btn-subtitle">Get Excel template with all fields</span>
              </span>
            </button>
          </div>
        </div>

        {/* Hidden file input */}
        <input
          type="file"
          id="fileInput"
          style={{ display: 'none' }}
          accept=".xlsx,.xls,.csv"
          onChange={handleFileUpload}
        />

        {/* Upload Status */}
        {uploadStatus && (
          <div className="upload-status">
            <div className={`status-message ${
              uploadStatus.includes('Error') || uploadStatus.includes('✗') ? 'error' : 
              uploadStatus.includes('Processing') ? 'processing' : 'success'
            }`}>
              <span className="status-text">{uploadStatus}</span>
              {!isUploading && (
                <button className="status-close" onClick={clearUploadStatus}>×</button>
              )}
            </div>
          </div>
        )}

        <div className="info-section">
          <div className="info-card">
            <h3>Excel Template Structure</h3>
            <div className="info-grid">
              <div className="infobp-item">
                <div className="info-header">
                  <span className="info-icon">👤</span>
                  <span className="info-label">Student Details</span>
                </div>
                <span className="info-value">Name, Contact, Education, Personal Information (12 fields)</span>
              </div>
              <div className="infobp-item">
                <div className="info-header">
                  <span className="info-icon">📚</span>
                  <span className="info-label">Course Details</span>
                </div>
                <span className="info-value">Course Type, Duration, Batch Schedule, Learning Mode (6 fields)</span>
              </div>
              <div className="infobp-item">
                <div className="info-header">
                  <span className="info-icon">💰</span>
                  <span className="info-label">Admission Details</span>
                </div>
                <span className="info-value">Fees, Payments, Dates, Registration Information (20 fields)</span>
              </div>
              <div className="infobp-item">
                <div className="info-header">
                  <span className="info-icon">👥</span>
                  <span className="info-label">Staff Overview</span>
                </div>
                <span className="info-value">Staff Assignment, Progress Tracking, Feedback (9 fields)</span>
              </div>
            </div>
          </div>

          {uploadedFile && (
            <div className="file-info-card">
              <h4>Uploaded File Information</h4>
              <div className="file-details">
                <div className="file-detail">
                  <span className="file-label">File Name:</span>
                  <span className="file-value">{uploadedFile.name}</span>
                </div>
                <div className="file-detail">
                  <span className="file-label">File Size:</span>
                  <span className="file-value">{(uploadedFile.size / 1024).toFixed(1)} KB</span>
                </div>
                <div className="file-detail">
                  <span className="file-label">Upload Time:</span>
                  <span className="file-value">{new Date().toLocaleString()}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Oldredirect;